import "./Tips.css";

const Tips = () => {
  return (
    <section className="tips-section py-5">
      <div className="container">
        <h2 className="section-title">Health Tips</h2>
        <div className="row">
          <div className="col-md-6 mb-4"> 
            <div className="tip-card h-100">
              <div className="tip-number">1</div>
              <div className="tip-content">
                <h4>Stay Active</h4>
                <p>Aim for at least 30 minutes of exercise daily</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-4">
            <div className="tip-card h-100">
              <div className="tip-number">2</div>
              <div className="tip-content">
                <h4>Balanced Diet</h4>
                <p>Include variety of fruits and vegetables</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-4">
            <div className="tip-card h-100">
              <div className="tip-number">3</div>
              <div className="tip-content">
                <h4>Hydration</h4>
                <p>Drink 8-10 glasses of water daily</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-4">
            <div className="tip-card h-100">
              <div className="tip-number">4</div>
              <div className="tip-content">
                <h4>Sleep Well</h4>
                <p>Get 7-8 hours of quality sleep</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tips;